import { clearAuthPersistence } from '~/lib/authStorage';
export const useLogout = (destination = '/') => {
  // Used directly as a click handler, so the first argument may be a DOM event
  const target = typeof destination === 'string' ? destination : '/';
  clearAuthPersistence();

  useTokens().$reset();
  useUser().$reset();
  useCosmo().$reset();
  useOwnerStore().reset();
  useParkerStore().reset();

  return navigateTo(target);
}
